var map = {
	"./barra.png": "2d2f",
	"./btnherramientas.png": "80bd",
	"./cancel.png": "17aa",
	"./check-green.png": "8c66",
	"./custom/blank.png": "b769",
	"./custom/checkered.png": "a072",
	"./custom/rowed.png": "53ee",
	"./double.png": "a690",
	"./draw/b1.png": "95b7",
	"./draw/check.svg": "c698",
	"./draw/cross.svg": "f250",
	"./draw/eraser-black.png": "9085",
	"./draw/link.svg": "0dee",
	"./draw/nicEditorIcons.gif": "2f61",
	"./draw/note.svg": "3e2e",
	"./draw/resaltador-black.png": "8a42",
	"./dropdown-arrow.png": "74b0",
	"./dropdown-arrow.svg": "2393",
	"./equis-red.png": "fe27",
	"./equis.png": "93f8",
	"./flecha.svg": "e689",
	"./flechaFooter-Active.svg": "33b6",
	"./flechafooter.svg": "1133",
	"./help.png": "d852",
	"./herramientas/cronometro.png": "7b58",
	"./herramientas/eraser-black.png": "3fe8",
	"./herramientas/eraser.png": "1a30",
	"./herramientas/fondo.png": "ba94",
	"./herramientas/link+.png": "0580",
	"./herramientas/link-.png": "55dd",
	"./herramientas/link.png": "8d50",
	"./herramientas/move.png": "9aac",
	"./herramientas/resaltador-black.png": "7068",
	"./herramientas/resaltador.png": "4913",
	"./herramientas/tampon.png": "0b62",
	"./hide.png": "5116",
	"./iconActi/audio.png": "c21b",
	"./iconActi/edit.png": "e05d",
	"./iconActi/icono-btnLINK.png": "a154",
	"./iconActi/teacher.png": "6b09",
	"./iconActi/video.png": "949f",
	"./iconActi/wbteacher.png": "4a1d",
	"./logo.png": "4ffd",
	"./lupa.png": "599c",
	"./mybook/blank.png": "f88c",
	"./mybook/checkered.png": "941c",
	"./mybook/rowed.png": "8cfb",
	"./next.svg": "dd0a",
	"./no-image.jpg": "64a0",
	"./paginas/LA/1.jpg": "3a36",
	"./paginas/LA/10.jpg": "5d8b",
	"./paginas/LA/11.jpg": "f16e",
	"./paginas/LA/12.jpg": "666c",
	"./paginas/LA/13.jpg": "3551",
	"./paginas/LA/14.jpg": "46db",
	"./paginas/LA/15.jpg": "0ef9",
	"./paginas/LA/16.jpg": "3fec",
	"./paginas/LA/2.jpg": "b2e1",
	"./paginas/LA/3.jpg": "7fd9",
	"./paginas/LA/4.jpg": "d496",
	"./paginas/LA/5.jpg": "616f",
	"./paginas/LA/6.jpg": "e679",
	"./paginas/LA/7.jpg": "9d266",
	"./paginas/LA/8.jpg": "b531",
	"./paginas/LA/9.jpg": "dd30",
	"./pdf.png": "77ef",
	"./recursos.png": "7b31",
	"./show.png": "41d5",
	"./single.png": "d1c0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";